module.exports = __webpack_public_path__ + "static/media/background.0547e8dc.png";